import { InputStyles } from 'components/layout/forms/AsyncSelect';

import Component from './component';

export interface Props {
    name?: string;
    label?: string;
    placeholder?: string;
    style?: InputStyles;
    value?: string;
    onChange?: (value: string) => void;
}

Component.defaultProps = {
    name: 'name',
    label: null,
    placeholder: null,
    style: InputStyles.Primary,
    value: '',
    onChange: () => null,
};

export default Component;
